export default __webpack_public_path__ + "static/media/mp-2.b4f288fa.png";